import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { GatewayChargePointInMaintenanceModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-charge-point-in-maintenance.model';
import { CellContext } from '@tanstack/react-table';

import { ChannelComponent } from './charge-point/channel/channel.component';

export interface ChargePointsConnectorsCellProps
  extends CellContext<
    GatewayChargePointInMaintenanceModel,
    GatewayChargePointInMaintenanceModel['channels']
  > {}

export const ChargePointsConnectorsCell = (
  props: ChargePointsConnectorsCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { getValue } = props;

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack gap={GapEnum.M} flexWrap="wrap">
      {getValue().map((channel) => (
        <ChannelComponent channel={channel} key={channel.id} />
      ))}
    </Stack>
  );
};
